import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

export const DiscoverBanner = () => (
  <section className="bg-white py-12 sm:py-16">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Link
        to="/discover"
        data-testid="discover-banner"
        className="group block relative overflow-hidden rounded-[28px] p-6 sm:p-10 shadow-2xl shadow-black/30"
        style={{ background: "linear-gradient(135deg,#0b0713 0%,#1b1030 55%,#2a1250 100%)" }}
      >
        <div className="absolute inset-0 grain opacity-40" />
        <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-violet-600/25 blur-3xl" />
        <div className="absolute -left-16 -bottom-16 h-64 w-64 rounded-full bg-fuchsia-500/20 blur-3xl" />
        <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 border border-white/15 px-3.5 py-1.5 text-[13px] font-bold text-teal-300">
              <Sparkles className="h-4 w-4" /> Free · No signup · 10-15 minutes
            </span>
            <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white leading-tight">
              Discover how your child <span className="brand-gradient-text">naturally learns.</span>
            </h2>
            <p className="mt-3 text-[16px] text-white/70 max-w-xl">
              A quick, playful activity for students in Grades 5 to 8. Get an instant visual strengths report, free.
            </p>
          </div>
          <span className="shrink-0 inline-flex items-center gap-2 rounded-full cta-gradient text-white px-7 h-14 text-[16px] font-bold shadow-lg shadow-violet-500/30 group-hover:gap-3 transition-all">
            Start Free <ArrowRight className="h-5 w-5" />
          </span>
        </div>
      </Link>
    </div>
  </section>
);

export default DiscoverBanner;
